/**
 * Količine na recepturi, po osnovi.
 *
 * Pekara računa u baker's percentage: linija je postotak brašna, a masa se
 * izvodi iz mase zamjesa (vidi recipeBatchLines). Slastičarna nema brašno kao
 * bazu — receptura je popis apsolutnih količina po jednoj šarži (2000 g, 3 lista
 * želatine), a gleda se i pomnožena množiteljem (x5, x7.5, x10), koji varira od
 * proizvoda do proizvoda i zato stoji uz recepturu.
 *
 * Pekarske metrike (hidracija, "Brašno PEK% = 100%") na apsolutnoj recepturi
 * nemaju značenje i ne smiju se računati — zato se ekrani granaju na
 * `isAbsoluteRecipe` prije nego pozovu calcRecipeMetrics.
 */

import { Recipe } from "../types/mes";
import { dateLocale } from "../i18n/locale";

export const isAbsoluteRecipe = (recipe?: Recipe | null): boolean =>
  recipe?.QuantityBasis === "absolute";

/** "5,7.5,10" -> [5, 7.5, 10]. Prihvaća i zarez kao decimalni znak. */
export const parseScaleFactors = (raw?: string | null): number[] => {
  if (!raw) return [];
  const nums = raw
    .split(/[;,]/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => Number(p.replace(",", ".")))
    .filter((n) => Number.isFinite(n) && n > 0);
  return nums.filter((n, i) => nums.indexOf(n) === i).sort((a, b) => a - b);
};

export const formatScaleFactor = (factor: number): string =>
  `x${Number.isInteger(factor) ? factor : String(factor).replace(".", ",")}`;

/**
 * Broj za prikaz. Zaokruživanje na tri decimale prati Decimal(12,3) u bazi —
 * bez toga se na x7.5 pojave repovi tipa 22,499999.
 */
export const formatQuantity = (value: number): string => {
  const rounded = Math.round(value * 1000) / 1000;
  return rounded.toLocaleString(dateLocale(), { maximumFractionDigits: 3 });
};
